import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { User } from '@gains-com/shared';
import { EnvironmentPipe } from '../../pipes/environment.pipe';

export interface UserAvatarVM {
  user_id: User['user_id'];
  username: User['username'];
  avatar_url: User['avatar_url'];
  subtitle?: string;
}

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EnvironmentPipe],
})
export class UserAvatarComponent {
  user = input.required<UserAvatarVM>();
}
